import React from "react";
import { Link } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";
import "../styles/saas.css";

export default function TrialStatusPage() {
  const { data, loading, error } = useSubscription();

  if (loading) return <div className="saas-page"><p>Loading trial status…</p></div>;
  if (error) return <div className="saas-page"><p className="saas-error">{error}</p></div>;

  const sub = data?.subscription;
  const company = data?.company;

  return (
    <div className="saas-page">
      <h1>Trial status</h1>
      {company && <p><strong>{company.company_name}</strong> — {company.status}</p>}
      {sub ? (
        <div className="saas-card">
          <p>Status: <strong>{sub.status}</strong></p>
          {sub.trial_ends_at && <p>Trial ends: {new Date(sub.trial_ends_at).toLocaleString("en-IN")}</p>}
          {sub.trial_days_remaining != null && <p>{sub.trial_days_remaining} days remaining</p>}
          {sub.plan && <p>Plan: {sub.plan.name}</p>}
          <Link to="/saas/subscription" className="saas-btn saas-btn--primary">Upgrade subscription</Link>
        </div>
      ) : (
        <p>No subscription record found for this workspace.</p>
      )}
    </div>
  );
}
